<div mat-dialog-title>{{ title }}</div>
<mat-dialog-content>
    <div *ngIf="isLoading"
         class="loading-container">
        <mat-spinner [diameter]="48"></mat-spinner>
        <div>{{ 'Loading' | translate }}</div>
    </div>
    <img *ngIf="!isLoading"
         class="image"
         src="{{ src }}" />
</mat-dialog-content>
<mat-dialog-actions>
    <button *ngIf="downloadEnabled"
            mat-button
            [disabled]="isDownloadLoading"
            (click)="onDownloadClicked()">
        {{ 'Download' | translate }}
    </button>
    <button mat-button
            mat-dialog-close>
        {{ 'Close' | translate}}
    </button>
</mat-dialog-actions>
<div class="progress-container">
    <mat-progress-bar *ngIf="isDownloadLoading" mode="indeterminate"></mat-progress-bar>
</div>
